import React, { Component } from 'react'
import t from '../components/Language/language'
import * as languageSettings from '../components/Language/languageSettings'
import DashboardComponent from '../components/Dashboard/DashboardComponent'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import Api from '../Api'
// import { getTimeMeasureType, getPermission } from '../../actions/roles'
import AuthenticationService from '../components/Security/AuthenticationService'

export default class DashboardContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      basicUser: false,
      dashboardData: {
      }
    }
    this.api = new Api()
  }

  componentWillMount () {
    this.getAccountSubscriptionType()
  }

  getAccountSubscriptionType () {
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAdminAcount + '?uuid=' + this.authService.getUUID()
    this.api.getData(url, data => {
      if (data.status) {
        if (data.data[0].Account_Subscription_ID === 4 || data.data[0].Account_Subscription_ID === 6) {
          this.setState({basicUser: false})
        } else {
          this.setState({basicUser: true})
        }
      }
    })
  }

  render () {
    if (this.state.basicUser) {
      let language = this.state.currentLanguage
      return (
        <div className='reportBasicUser '>
          <h3 className='up_head'>{t[language].Upgradeyouraccount}</h3>
          <h5 className='up_sub'>{t[language].Toupgradenow}, {t[language].pleasecall}:</h5>
          <div className='contactList'>
            <div className='contact-d row'>
              <span className='contact-dr col-xs-12 col-sm-4 col-md-2'>{t[language].DomesticSales}:</span>
              <span className='col-sm-8 col-xs-12 col-md-10'>1-800-848-4468 {t[language].Options} 1, 1, 1</span>
            </div>
            <div className='contact-d row'>
              <span className='contact-dr col-xs-12 col-sm-4 col-md-2'>{t[language].InternationalSales}:</span>
              <span className='col-sm-8 col-xs-12 col-md-10'>1-800-848-4468 {t[language].Options} 1, 1, 2, 1 {t[language].for} Canada/Mexico/Latin America/South America/Bahamas/Puerto Rico</span>
            </div>
            <div className='contact-d row'>
              <span className='contact-dr col-xs-12 col-sm-4 col-md-2' />
              <span className='col-sm-8 col-xs-12 col-md-10'>1-800-848-4468 {t[language].Options} 1, 1, 2, 2 {t[language].for} {t[language].othercountries}</span>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <DashboardComponent />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.js